










































































































































import Vue from "vue";
import vIcon from "@/components/v-components/v-icon.vue";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import VelloIcon from "@/components/vue-components/VelloIcon.vue";

export default Vue.extend({
  name: "ResetPassword",
  components: { vIcon, VelloIcon },
  props: {
    uid: {
      type: String,
      default: null
    },
    expire: {
      type: String,
      default: null
    },
    hash: {
      type: String,
      default: null
    },
    token: {
      type: String,
      default: null
    }
  },
  data: () => {
    return {
      newPassword: "" as string,
      confirmPassword: "" as string,
      minimum: 15 as number,
      maximum: 120 as number,
      errors: {
        new_missing: false,
        confirm_missing: false,
        no_match: false,
        too_short: false,
        too_long: false,
        no_uppercase: false,
        no_lowercase: false,
        no_number: false,
        no_special_char: false,
        used_before: false
      } as { [key: string]: boolean },
      status: "base" as string,
      loading: false as boolean,
      success: false as boolean
    };
  },
  computed: {
    ...mapGetters([
      "GET_CSRF_INFORMATION",
      "GET_USER_STATUS",
      "COMPANY_GET_COMPANY"
    ]),
    passwordErrorLabel(): string {
      if (this.errors.used_before) return this.$t("reset-password.form.input-pswd-error-used-before") as string;
      if (this.errors.new_missing) return this.$t("reset-password.form.input-pswd-error-missing") as string;
      if (this.errors.too_short) return this.$t("reset-password.form.input-pswd-error-too-short") as string;
      if (this.errors.too_long) return this.$t("reset-password.form.input-pswd-error-too-long") as string;
      if (this.errors.no_uppercase) return this.$t("reset-password.form.input-pswd-error-no-uppercase") as string;
      if (this.errors.no_lowercase) return this.$t("reset-password.form.input-pswd-error-no-lowercase") as string;
      if (this.errors.no_number) return this.$t("reset-password.form.input-pswd-error-no-number") as string;
      if (this.errors.no_special_char) return this.$t("reset-password.form.input-pswd-error-no-special-char") as string;
      return this.$t("reset-password.form.input-pswd") as string;
    },
    hasPasswordError(): boolean {
      return this.errors.new_missing || this.errors.too_short || this.errors.too_long ||
        this.errors.no_uppercase || this.errors.no_lowercase || this.errors.no_number ||
        this.errors.no_special_char || this.errors.used_before;
    }
  },
  methods: {
    ...mapActions(["USER_ONETIME_LOGIN", "COMPANY_FETCH_COMPANY"]),

    isExpired(): boolean {
      const isExpired = moment(moment().unix()).isAfter(parseInt(this.expire));
      if (isExpired) this.status === "expired";
      return isExpired;
    },

    handleFormSubmit(): void {
      this.loading = true;
      Object.keys(this.errors).forEach(key => (this.errors[key] = false));

      this.errors.new_missing = !this.newPassword;
      this.errors.confirm_missing = !this.confirmPassword;
      this.errors.no_match = !(this.newPassword === this.confirmPassword);
      this.errors.too_short = this.newPassword.length < this.minimum;
      this.errors.too_long = this.newPassword.length > this.maximum;
      this.errors.no_uppercase = !!this.newPassword && !/[A-Z]/.test(this.newPassword);
      this.errors.no_lowercase = !!this.newPassword && !/[a-z]/.test(this.newPassword);
      this.errors.no_number = !!this.newPassword && !/[0-9]/.test(this.newPassword);
      this.errors.no_special_char = !!this.newPassword && !/[^A-Za-z0-9]/.test(this.newPassword);

      if (Object.keys(this.errors).every(key => !this.errors[key])) {
        this.$store
          .dispatch("USER_ONETIME_LOGIN", {
            credentials: {
              uid: this.$props.uid,
              expire: this.$props.expire,
              hash: this.$props.hash,
              token: this.$props.token,
              password: this.newPassword
            },
            token: this.GET_CSRF_INFORMATION.token
          })
          .then(() => {
            if (this.GET_USER_STATUS.user._default_company) {
              return this.$store.dispatch("COMPANY_FETCH_COMPANY", {
                id: this.GET_USER_STATUS.user._default_company,
                token: this.GET_CSRF_INFORMATION.token
              });
            } else {
              return;
            }
          })
          .then(() => {
            this.loading = false;
            this.success = true;
            setTimeout(() => {
              this.status = "done";
            }, 500);
          })
          .catch(error => {
            this.loading = false;
            this.status = "base";
            if (
              error &&
              error.message &&
              error.message.includes("Password has been used before")
            ) {
              this.errors.used_before = true;
            } else {
              this.$store.dispatch("UPDATE_NOTIFICATION_STATUS", {
                status: true,
                component: "error"
              });
              throw new Error("Password reset error");
            }
          });
      } else {
        this.loading = false;
        this.status = "base";
      }
    },

    handleClickContinue(): void {
      this.$router.push({ name: "Login" });
    }
  }
});
